// Everything on /tectonics that is expected to change lives here.

// Shown above the headline. Set to null after Oct 29 to remove it.
export const EVENT_LINE: string | null = 'Swimming with Narwhals finalist · Pitching Wed 10/28, 5pm';

// The 60-second demo. Either a self-hosted .mp4 (a path under /public, played
// in a native video player) or a YouTube or Vimeo share link.
// While empty, the video block is hidden (a placeholder shows in development).
export const VIDEO_URL = '/video/cadence-demo-web.mp4';

// Poster frame shown before playback (a path under /public or a full URL).
// If empty, YouTube links use YouTube's own thumbnail, and .mp4 and Vimeo
// show a plain dark frame.
export const VIDEO_POSTER = '/video/cadence-demo-poster.jpg';

// The ID of the Tally form that collects event details: the part after
// tally.so/r/ in the form's share link. While empty, the page shows a
// labelled placeholder in the form slot.
// The form needs hidden fields named exactly "source" and "qr". It is embedded
// with a transparent background on the navy page, so in Tally's Customize
// panel give it light text and a #00B7C2 button.
export const TALLY_FORM_ID = 'QoKJlk';

// Where "Book a call" goes on this page, both under the form and in the
// thank-you message. The rest of the site uses BOOKING_URL in src/siteConfig.ts.
export const BOOKING_URL = 'https://cal.com/cadenceio/discovery-call';

// Written into the form's hidden "source" field on every submission.
export const FORM_SOURCE = 'tectonics';

// Allowed values for ?s= in the QR code URLs, written into the hidden "qr"
// field. Anything else is ignored.
export const QR_SOURCES = ['sign', 'card', 'deck', 'badge'];
